module.exports = __webpack_public_path__ + "static/img/2.b188221.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/2.png
// module id = W1BO
// module chunks = 0